import React from 'react';
import { disabledPerformanceDate } from '@constants';
import { RangePicker } from '@ui';
import { FILTER_PARAMS, MENU_ITEMS } from '../../constants';
import MenuItem from './components/Item';
import { StyledMenu, StyledRangePickerWrapper, StyledWrapper } from './styled';

const Menu = ({ onDateChange, dateValue, activeAnchor }) => {
    const handleDataChange = (data) => {
        if (typeof onDateChange !== 'function') return;
        onDateChange({
            [FILTER_PARAMS.DATE_FROM]: data.min,
            [FILTER_PARAMS.DATE_TO]: data.max
        });
    };

    return (
        <StyledWrapper>
            <StyledMenu data-e2e='performance_menu_section'>
                {MENU_ITEMS.map((item) => (
                    <MenuItem
                        key={item.id}
                        title={item.title}
                        active={activeAnchor === item.id}
                        onClick={() => document.getElementById(item.id)?.scrollIntoView({ behavior: 'smooth' })}
                    />
                ))}
                <StyledRangePickerWrapper data-e2e='performance_date-picker_btn'>
                    <RangePicker
                        key='date-picker'
                        value={dateValue}
                        allowClear={false}
                        disabledDate={disabledPerformanceDate}
                        onChange={handleDataChange}
                    />
                </StyledRangePickerWrapper>
            </StyledMenu>
        </StyledWrapper>
    );
};

export default Menu;
